import $ from "jquery"
import * as ers from "../../../errorsmessages/errors"
import * as suc from "../../../successmessages/success"
import * as rt from "../../../routes/routes"
import AuthService from "../../../configurations/authentications/auth";
import baseurl from "../../../configurations/baseurl/baseurl"
import router from "../../../router/index"
import decode from "jwt-decode";

const Auth = new AuthService();

export const actions = {

    LoginUser({ commit, dispatch }) {
        $('.signButton').hide()
        $('.loagingLoader').show()
        const loginDetails = {
            email: $('.emailAddress').val(),
            password: $('.userPassword').val()
        }

        baseurl
            .post(rt.accountLogin, loginDetails)
            .then(res => {
               
                $('.signButton').show()
                $('.loagingLoader').hide()
                if (res.data.code === 200) {
                    let payload = decode(res.data.token);
                    Auth.isTokenExpired(payload.exp + Date.now());
                    Auth.setuserRoleModules(JSON.stringify(res.data.roleModules))                   
                    Auth.setUsername(res.data.user.profilename)
                    Auth.setprofile(res.data.user.profile_img)
                    Auth.setToken(res.data.token); //successfull login
                    commit('STORE_CURRENT_USERNAME', res.data.user.profilename)
                    commit('STORE_CURRENT_PIC', res.data.user.profile_img)
                    commit('STORE_USER_ROLES_MODULES', res.data.roleModules)                   
                    suc.logginSuccess()
                    setTimeout(() => {
                        router.push('/dashboard')
                    }, 3000);

                } else if (res.data.code === 401) {
                    ers.wrongPasswordError()
                    commit('STORE_USERLOGIN_ATTEMPTS', res.data.attempts)
                    $('.userLoginAttempts').show()
                } else if (res.data.code === 402) {
                    ers.validateErrors()
                } else if (res.data.code === 403) {
                    ers.accountNotExists()
                } else if (res.data.code === 407) {
                    ers.accountTemperaryDisabled()
                } else if (res.data.code === 408) {
                    ers.accountClosed()
                } else if (res.data.code === 409) {
                    ers.accountPending()
                }

            })
    },

    hideLogingAttempts() {
        $('.userLoginAttempts').hide()
    }

};
export default actions



// WEBPACK FOOTER //
// ./src/vuex/modules/auth/actions.js